// earth.js: HOME chapter. Implementation in ./earth/ (world.js, rig.js, glsl.js).
export { create } from './earth/world.js';
